import { useEffect, useContext } from "react";

import PermissionContext from "../../../context/PermissionContext";
import DrawerContext from "../../../context/DrawerContext";
import AutoLogout from "../../../utils/useAutoLogout";
import EncapsulantPhaseContext from "../../../context/materialcapture/EncapsulantPhaseContext";

import SideDrawer from "../../../components/layout/SideDrawer";
import SuccessAlert from "../../../components/layout/SuccessAlert";
import Loader from "../../../components/layout/Loader";
import ErrorModal from "../../../components/layout/ErrorModal";
import TopBarWithBack from "../../../components/layout/TopBarWithBack";
import EncapsulantPhaseForm from "../../../components/materialscapture/EncapsulantPhaseForm";
import Tab from "../../../components/layout/Tab";
import BulkUploadForm from "../../../components/materialscapture/BulkUploadForm";

const EncapsulantPhaseCreatePage = () => {
  const { permisionsList, checkUserPermission } = useContext(PermissionContext);
  const { drawerValue, setDrawerValue } = useContext(DrawerContext);
  const { 
    apiRes, setApiRes, formErrors, tabArray, handleTabChange, 
    tabValue, handleSubmit, uploadInitValues, setUploadInitValues
  } = useContext(EncapsulantPhaseContext);

  const backURL = '/materials-capture';

  useEffect(() => {
    if(permisionsList.length > 0) checkUserPermission(['Materials Capture-Encapsulation Details']);
  }, [permisionsList]);

  return(
    <AutoLogout>
      <SideDrawer drawerValue={drawerValue} setDrawerValue={setDrawerValue} />
      {apiRes.loading && <Loader />}
      <div className="mainContainer" style={{ marginLeft: drawerValue.drawerWidth }}>
        {apiRes.showAlert && <SuccessAlert apiRes={apiRes} setApiRes={setApiRes} />}
        <TopBarWithBack title={'Encapsulation Details'} backURL={backURL} />
        <Tab 
          tabArray={tabArray} 
          handleTabChange={handleTabChange} 
          tabValue={tabValue} 
        />

        {tabValue === 'Manual' && <EncapsulantPhaseForm />}
        {tabValue === 'File Upload' && 
          <BulkUploadForm 
            apiRes={apiRes} 
            setApiRes={setApiRes} 
            formErrors={formErrors} 
            onSubmit={handleSubmit} 
            uploadInitValues={uploadInitValues} 
            setUploadInitValues={setUploadInitValues} 
          />
        }

        <ErrorModal apiRes={apiRes} setApiRes={setApiRes} />
      </div>
    </AutoLogout>
  );
};

export default EncapsulantPhaseCreatePage;